import React, { useContext, useEffect, useState, useLayoutEffect, useRef } from 'react';
import { useSearchParams, useLocation, useNavigate, useParams} from 'react-router-dom';

import AppContext from './AppContext'

const ScroolHook = (props) => {

    const {rolagemAuto, rolagemAutoIntervalo} = useContext(AppContext);
    const elementRef = useRef()

    let atualChild = undefined;
   
    const stepAnimaton = process.env.REACT_APP_SCROOL_STEP_TIME || 3000;

    //Limpa todos os intervalos existentes
    const clearAllIntervals = (windowObj) => {
        const interval_id = windowObj.setInterval(function(){}, Number.MAX_SAFE_INTEGER);    
        for (let i = 1; i < interval_id; i++) {      
            windowObj.clearInterval(i);
        }
    }

    const childStep = (child,parent) => { 
        var childpos = child.getBoundingClientRect();  
        var parentpos = parent.getBoundingClientRect();          
        let step = Math.round(parentpos.width/childpos.width)        
        if(step>1){
            return step            
        }
        return 1
    }   

    const firstVisibleChild = (childs,parent) => {        
        
        for (var i = 0; i < childs.length; i++){
            if(elementIsVisible(childs[i],parent)){                
                return i
            }
        }
        return 0;        
    }

    const elementIsVisible = (element, parent) =>{
        var position = element.getBoundingClientRect();        
        const containerRect = parent.getBoundingClientRect();
 
        return position.top <= containerRect.top ? containerRect.top - position.top <= position.height : position.bottom - containerRect.bottom <= position.height;
    }    

    const elementIsFullVisible = (element, parent) =>{
        const eleTop = element.offsetTop;
        const eleBottom = eleTop + element.clientHeight;

        const containerTop = parent.scrollTop;
        const containerBottom = containerTop + parent.clientHeight; 

        return (
            ((eleTop - element.clientHeight)  >= containerTop && eleBottom <= containerBottom) ||            
            (eleTop <= containerTop && containerTop <= eleBottom) ||
            (eleTop <= containerBottom && containerBottom <= eleBottom)
        );        
    }

    const elementIsPartialyVisibleTreshold = (element, parent, treshold) =>{
        var position = element.getBoundingClientRect();        
        const containerRect = parent.getBoundingClientRect();
        
        if(position.top <= containerRect.top){
            return(containerRect.top - position.top <= (position.height * (1- treshold)))
        }else{
            return(position.bottom - containerRect.bottom <= (position.height * (1- treshold)))
        }
        //return position.top <= containerRect.top ? containerRect.top - position.top <= (position.height * (1- treshold) : position.bottom - containerRect.bottom <= (position.height * 0.8);
    }

    const scrollStep = (element) => {   

        let childs = element.children;        
        
        if(childs.length>0){

            atualChild=0                        
            setInterval(() => {                                            
                //get first visible child 
                if(atualChild<=childs.length-1){
                    atualChild=firstVisibleChild(childs,element)                    
                    atualChild+=childStep(childs[atualChild],element)                 
                }else{                    
                    atualChild=0
                }
                                
                childs[atualChild].scrollIntoView({behavior: "smooth"});                                                 

                if(elementIsVisible(element.lastChild, element)){
                    atualChild=childs.length
                }                    
            }, rolagemAutoIntervalo||3000);            
        }

    }

    //Scrool Animation
    const handleScrollAnimation = event => {

        let element = elementRef?.current
        let childs = element.children;        
        
        if(childs.length>0){

            for (var i = 0; i < childs.length; i++){                                   
                if(elementIsFullVisible(childs[i],element)){         
                    childs[i].classList.remove("item-hidden");
                    childs[i].classList.remove("item-parcial");                        
                }else{
                    if(elementIsVisible(childs[i],element)){                    
                        if(elementIsPartialyVisibleTreshold(childs[i],element,0.2)){
                            childs[i].classList.add("item-parcial");     
                            childs[i].classList.remove("item-hidden");                              
                        }else{
                            childs[i].classList.add("item-hidden");     
                            childs[i].classList.remove("item-parcial");  
                        }
                    }else{
                        childs[i].classList.add("item-hidden");
                        childs[i].classList.remove("item-parcial");       
                    }
                }
            }
        }
    };


    //Scrool control
    useLayoutEffect(() => {       
               
        //process resize screen
        window.addEventListener('resize', ()=>{
            if(rolagemAuto){
                clearAllIntervals(window)
                if(props?.listaDados && elementRef?.current){
                   scrollStep(elementRef?.current)
                }
            }else{
                clearAllIntervals(window)
            }
        });  
        
        if(rolagemAuto){
            clearAllIntervals(window)             
            if(props?.listaDados && elementRef?.current){                            
                scrollStep(elementRef?.current)    
            }
        }else{
           clearAllIntervals(window)
        }
    
    }, [elementRef, props.listaDados, rolagemAuto, rolagemAutoIntervalo]);   

    return(
        <div ref={elementRef} 
            className={`flex flex-wrap gap-vhw w-full scroolable h-full align-content-start ${props.className || ''}`} 
            onScroll={props.scroolAnimation ? handleScrollAnimation : null} >
                {props.children}
        </div>
    );    
}

export default ScroolHook;